export const Gruping = (groupBy, col) => Array.isArray(groupBy) && groupBy.indexOf(col.dataField);
